import { useEffect, useState } from "react";
import {
  fetchSalesTimelyComparisonCharts,
  SalesTimelyComparisonChartsResponse,
  SalesTimelyComparisonPeriod,
} from "../services/salesTimelyComparisonDashboardApi";

interface SalesTimelyComparisonChartsState {
  data: SalesTimelyComparisonChartsResponse | null;
  isLoading: boolean;
  error: string | null;
}

const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) return error.message;
  return "Failed to load Sales trend charts.";
};

export const useSalesTimelyComparisonCharts = (
  period: SalesTimelyComparisonPeriod,
  enabled: boolean,
  refreshKey = 0,
): SalesTimelyComparisonChartsState => {
  const [state, setState] = useState<SalesTimelyComparisonChartsState>({
    data: null,
    isLoading: false,
    error: null,
  });

  useEffect(() => {
    if (!enabled) return;

    let isCurrent = true;

    setState((current) => ({
      ...current,
      isLoading: true,
      error: null,
    }));

    fetchSalesTimelyComparisonCharts(period)
      .then((data) => {
        if (!isCurrent) return;
        setState({ data, isLoading: false, error: null });
      })
      .catch((error) => {
        if (!isCurrent) return;
        setState((current) => ({
          ...current,
          isLoading: false,
          error: getErrorMessage(error),
        }));
      });

    return () => {
      isCurrent = false;
    };
  }, [enabled, period, refreshKey]);

  return state;
};
